import { z } from "zod";
import { getWikiSpacesParamsSchema } from "./get-wiki-spaces.schema";

export const getWikiPageParamsSchema = z
	.object({
		pageId: z.string(),
	})
	.and(getWikiSpacesParamsSchema);
